import CoreImg from 'shared/CoreImg';
import { PictureAvatar, PictureWrapper } from './style';
import { IAvatar, SizeType } from './type';

const CorePictureAvatar = ({ size, color_type, text, picture, _disabled }: IAvatar) => {
	const size_value: Record<SizeType, number> = {
		small: 32,
		default: 48,
		large: 80,
	};

	return (
		<PictureAvatar
			size_type={size}
			color_type={color_type}
			is_picture={picture ? true : false}
			_disabled={_disabled}
		>
			{!picture && text ? text[0] : ''}
			{picture && (
				<PictureWrapper>
					<CoreImg
						src={picture}
						alt="avatar-image"
						error_src="https://featuring-score-web.s3.amazonaws.com/static/images/score/v3/common/cmmn-default-image.png"
						_width={size_value[size]}
						_height={size_value[size]}
						lazy
					/>
				</PictureWrapper>
			)}
		</PictureAvatar>
	);
};

export default CorePictureAvatar;

// props
// - size: large, default, small
// - picture: 사진이 있을 경우 사진의 경로
